import { AxiosResponse } from 'axios'
import { api } from '@/lib/api-client.ts'
import { components } from '@/lib/types/api-types.ts'
import { QueryKey } from '@tanstack/react-query'
import { User } from '@/store/user'
export const userQueryKey: QueryKey = ['user', 'me']

type FileUpload = components['schemas']['MediaObject.jsonld-media_object.read']
export const uploadFile = async ({
  file,
  owningProjectStage,
  uuid,
  fileUUID,
}: {
  file: File
  owningProjectStage?: string | undefined | null
  uuid?: string
  fileUUID?: string
}): Promise<AxiosResponse<FileUpload>> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('fileUUID', fileUUID ?? crypto.randomUUID())
  if (owningProjectStage) {
    formData.append('owningProjectStage', owningProjectStage)
  }
  if (uuid) {
    formData.append('requestUUID', uuid)
  }

  return api.post(`/media_objects`, formData)
}

export const currentUserQuery = () => ({
  queryKey: userQueryKey,
  queryFn: () => getCurrentUser(),
})

export const getCurrentUser = async function () {
  const res: AxiosResponse = await api.get('/users/me')
  const userData: User = res.data
  return userData
}
